export default __webpack_public_path__ + "static/media/5.85525b4c.png";